/** css */
import './GanttMassiveTag.css';
import GanttMassiveTag from './GanttMassiveTag';

export default GanttMassiveTag;
